<template>
    <flex-element :element-type="elementType" v-html="richText" />
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';

export default {
    name: 'a-heading-rich',
    mixins: [baseAtom],

    props: {
        richText: {
            type: String,
            default: '',
        },
    },
};
</script>
